import { ImageWithTranslation } from "@common/types/ImageWithTranslation";
import LocalImage from "@common/components/LocalImage";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

type Props = {
  vehicleDefaultImage: ImageWithTranslation;
};

const VehicleCoverImageFrame = ({ vehicleDefaultImage }: Props) => {
  const { t } = useTranslation(["purchase", "common"]);
  const locale = useRouter().locale || "en";

  return (
    <div className="relative min-w-full inset-0">
      <div className="overflow-auto relative h-56 md:h-96">
        <LocalImage
          className="z-[2] w-full object-contain h-auto rounded-lg"
          src={
            locale === "fr"
              ? vehicleDefaultImage.srcFr
              : vehicleDefaultImage.srcEn
          }
          alt={t(vehicleDefaultImage.altKey)}
          fill
        />
      </div>
    </div>
  );
};

export default VehicleCoverImageFrame;
